import { render, staticRenderFns } from "./AboutMembers.vue?vue&type=template&id=55940e1f&"
import script from "./AboutMembers.vue?vue&type=script&lang=js&"
export * from "./AboutMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports